const BranchSiteOutput = props => {
    const value = props.question ? props.question.value : props.value;

    return value ? `${value.org_name} (${value.org_code})` : '';
};

export default BranchSiteOutput;
